// import React from 'react';

// // ClientLogo Component to render individual client logos
// const ClientLogo = ({ imageSrc, altText }) => (
//   <div className="col-md-3 col-sm-4 col-xs-6 ">
//     <span className="client_img image_hover">
//       <img src={imageSrc} className="img-responsive zoom_img_effect" alt={altText} />
//     </span>
//   </div>
// );

// const OurClients = () => {
//   const clientLogos = [
//     { src: "/images/Logo-client.jpg", alt: "Client Logo 1" },
//     { src: "/images/logo-client2.png", alt: "Client Logo 2" },
//     { src: "/images/logo-client4.jpg", alt: "Client Logo 3" },
//     { src: "/images/logo-client5.jpg", alt: "Client Logo 3" },
//     { src: "/images/logo-client6.jpg", alt: "Client Logo 3" },
//     { src: "/images/logo-client7.webp", alt: "Client Logo 3" },
//   ];

//   return (
//     <div className="row container-fluid  ">
//       <div className="head-section client-head">
//         <div className="col-md-3 col-sm-4 col-xs-12">
//           <h3>Our Clients</h3>
//         </div>
//         <div className="col-md-12 col-sm-8 col-xs-12">
//           <p className="fnt-18">
//             At Anjali Enterprises, we specialize in providing high-quality aluminium glass windows, soundproof glass solutions, and mosquito net installations. Our expert team is committed to delivering exceptional craftsmanship and ensuring customer satisfaction with every project. Whether you're looking for innovative office partitions or durable exterior solutions, we are dedicated to transforming your space with precision and professionalism.
//           </p>
//         </div>
//       </div>

//       <div className="client_hover border p-0">
//         {/* Render each client logo dynamically */}
//         <div className="container-fluid">
//           {clientLogos.map((logo, index) => (
//             <ClientLogo key={index} imageSrc={logo.src} altText={logo.alt} />
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OurClients;




import React from 'react';
import './OurClients.css';

const OurClients = () => {
  const clientLogos = [
    { src: "/images/Logo-client.jpg", alt: "Client Logo 1" },
    { src: "/images/logo-client2.png", alt: "Client Logo 2" },
    { src: "/images/logo-client4.jpg", alt: "Client Logo 3" },
    { src: "/images/logo-client5.jpg", alt: "Client Logo 4" },
    { src: "/images/logo-client6.jpg", alt: "Client Logo 5" },
    { src: "/images/logo-client7.webp", alt: "Client Logo 6" },
  ];

  // Duplicate logos for seamless infinite sliding
  const logos = [...clientLogos, ...clientLogos];

  return (
    <div className="our-clients container-fluid">
      <div className="head-section client-head">
        <div className="client-title">
          <h3>Our Clients</h3>
        </div>

        <div className="client-description">
          <p className="fnt-18">
            At Anjali Enterprises, we specialize in providing high-quality
            aluminium glass windows, soundproof glass solutions, and mosquito
            net installations. Our expert team is committed to delivering
            exceptional craftsmanship and ensuring customer satisfaction with
            every project. Whether you're looking for innovative office
            partitions or durable exterior solutions, we are dedicated to
            transforming your space with precision and professionalism.
          </p>
        </div>
      </div>

      <div className="client-slider">
        <div className="client-track">
          {logos.map((logo, index) => (
            <div className="client-slide" key={index}>
              <div className="client-logo-box">
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="client-logo"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurClients;

